export default {"src":"https://static.spiritory.com/_next/static/media/2.b5f54562.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};